import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  ChangeDetectorRef
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatRadioChange } from "@angular/material/radio";
import {
  PAYMENT_OPTION_EPP,
  PAYMENT_OPTION_EPP_3_6_12_MONTHS,
  PAYMENT_OPTION_EPP_6_12_MONTHS,
  PAYMENT_OPTION_EWALLET,
  PAYMENT_OPTION_FP,
  PAYMENT_OPTION_FPX,
  PAYMENT_OPTION_FPX_ENTERPRISE,
  PAYMENT_OPTION_PAYEX,
  PAYMENT_OPTION_RAZER,
  PAYMENT_OPTION_SHOPBACK,
  PAYMENT_OPTION_SHOPEE,
  PAYMENT_OPTION_VISA,
  PAYMENT_OPTION_ATOME,
  PAYMENT_OPTION_AHAPAY,
  PAYMENT_OPTION_BNPL,
  PAYMENT_OPTION_GRAB,
  PAYMENT_OPTION_MSD,
  PAYMENT_OPTION_KITS,
  PAYMENT_OPTION_MPAY,
  PAYMENT_OPTION_GRAB_MINIAPP,
  PAYMENT_OPTION_LENDAPAY
} from "src/app/share/constants/payment-options";
import {
  PAYMENT_EPP_TYPE,
  PAYMENT_EWALLET_TYPE,
  PAYMENT_FPX_ENTERPRISE_TYPE
} from "src/app/share/constants/payment-options";
import {
  EPPChargeInterface,
  IMotorPartnerPaymentSettings
} from "src/app/share/interface/motor.interface";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-payment-options",
  templateUrl: "./payment-options.component.html",
  styleUrls: ["./payment-options.component.scss"]
})
export class PaymentOptionsComponent implements OnInit, OnChanges {
  private static readonly PaymentMethod = {
    Razer:   'Razer',
    Atome:   'Atome',
    AhaPay:  'AhaPay',
    Shopee:  'ShopeePay',
    Grab:    'GrabPay',
    RazerEPP:'RazerEPP',
    PayexEPP:'PayexEPP',
  } as const;

  // Shopback is only turn on in staging + UAT, never production.
  enableShopback: boolean = environment.enableShopback;
  paymentOptionShopback: string = PAYMENT_OPTION_SHOPBACK;
  paymentOptionFullPrice: string = PAYMENT_OPTION_FP;
  paymentOptionRazer: string = PAYMENT_OPTION_RAZER;
  paymentOptionPayex: string = PAYMENT_OPTION_PAYEX;
  paymentOptionEPP: string = PAYMENT_OPTION_EPP;
  paymentOptionGrab: string = PAYMENT_OPTION_GRAB;
  paymentOptionShopee: string = PAYMENT_OPTION_SHOPEE;
  paymentOptionEPP3Or6Or12Months: string = PAYMENT_OPTION_EPP_3_6_12_MONTHS;
  paymentOptionEPP6Or12Months: string = PAYMENT_OPTION_EPP_6_12_MONTHS;
  paymentOptionVisa: string = PAYMENT_OPTION_VISA;
  paymentOptionEwallet: string = PAYMENT_OPTION_EWALLET;
  paymentOptionFpx: string = PAYMENT_OPTION_FPX;
  paymentOptionFpxEnterprise: string = PAYMENT_OPTION_FPX_ENTERPRISE;
  paymentOptionAtome: string = PAYMENT_OPTION_ATOME;
  paymentOptionAhaPay: string = PAYMENT_OPTION_AHAPAY;
  paymentOptionBNPL: string = PAYMENT_OPTION_BNPL;
  paymentOptionMSD: string = PAYMENT_OPTION_MSD;
  paymentOptionMPay: string = PAYMENT_OPTION_MPAY;
  paymentOptionKITS: string = PAYMENT_OPTION_KITS;
  paymentOptionGrabMiniApp: string = PAYMENT_OPTION_GRAB_MINIAPP;
  paymentOptionLendaPay: string = PAYMENT_OPTION_LENDAPAY;
  ewalletTypeListing: any[] = PAYMENT_EWALLET_TYPE;
  fpxEnterpriseTypeListing: any[] = PAYMENT_FPX_ENTERPRISE_TYPE;
  eppTypeListing: any[] = PAYMENT_EPP_TYPE;
  totalPriceAfterCharge: number;
  epp3Or6Or12MonthsChargeList: EPPChargeInterface[] = [];
  epp6Or12MonthsChargeList: EPPChargeInterface[] = [];
  epp3Or6Or12MonthsChargeDistinctList: EPPChargeInterface[] = [];
  epp6Or12MonthsChargeDistinctList: EPPChargeInterface[] = [];
  epp3Or6Or12MonthsMinAmount: number;
  epp6Or12MonthsMinAmount: number;
  showEPP3Or6Or12Months: boolean = false;
  showEPP6Or12Months: boolean = false;
  totalPriceInstallment3: number;
  totalPriceInstallment6: number;
  totalPriceInstallment12: number;

  @Input() totalPrice: number;
  @Input() totalPriceBeforeCharges: number;
  @Input() bankCharge: { 3: number; 6: number; 12: number };
  @Input() paymentFormGroup: FormGroup;
  @Input() onlyFullPayment?: boolean = false;
  @Input() allowEwallet?: boolean = true;
  @Input() paymentOptionsCondition?: IMotorPartnerPaymentSettings;
  @Input() eppChargeList: EPPChargeInterface[];
  @Input() partnerCode?: string;
  @Input() previousTriedPayment?: string;
  @Input() disabledAtome?: boolean = false;
  @Input() disabledAhapay?: boolean = false;
  @Input() isEndorsement?: boolean = false;
  @Input() isTakafulProduct: boolean = false;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.totalPriceInstallment3 =
      (this.totalPriceBeforeCharges + this.bankCharge?.["3"]) / 3;
    this.totalPriceInstallment6 =
      (this.totalPriceBeforeCharges + this.bankCharge?.["6"]) / 6;
    this.totalPriceInstallment12 =
      (this.totalPriceBeforeCharges + this.bankCharge?.["12"]) / 12;

    if (this.eppChargeList && this.eppChargeList.length > 0) {
      this.epp3Or6Or12MonthsChargeList = this.eppChargeList
        .filter(
          (eppCharge) =>
            eppCharge.provider === this.paymentOptionRazer &&
            this.totalPriceBeforeCharges >= eppCharge.minAmount &&
            (eppCharge.maxAmount == null ||
              this.totalPriceBeforeCharges <= eppCharge.maxAmount)
        )
        .sort(function (a, b) {
          var textA = a.installmentPeriod;
          var textB = b.installmentPeriod;
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
      this.epp3Or6Or12MonthsMinAmount = Math.min(
        ...this.epp3Or6Or12MonthsChargeList.map(
          (eppCharge) => eppCharge.minAmount
        )
      );
      this.showEPP3Or6Or12Months =
        this.totalPriceBeforeCharges >= this.epp3Or6Or12MonthsMinAmount;

      const groupByBankName1 = this.epp3Or6Or12MonthsChargeList.reduce(
        (group, eppCharge) => {
          const { bankName } = eppCharge;
          group[bankName] = group[bankName] ?? [];
          group[bankName].push(eppCharge);
          return group;
        },
        {}
      );

      this.epp3Or6Or12MonthsChargeDistinctList = Object.values(groupByBankName1)
        .map((group) => group[0])
        .sort(function (a, b) {
          var textA = a.bankName.toUpperCase();
          var textB = b.bankName.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

      this.epp6Or12MonthsChargeList = this.eppChargeList
        .filter(
          (eppCharge) =>
            eppCharge.provider === this.paymentOptionPayex &&
            this.totalPriceBeforeCharges >= eppCharge.minAmount &&
            (eppCharge.maxAmount == null ||
              this.totalPriceBeforeCharges <= eppCharge.maxAmount)
        )
        .sort(function (a, b) {
          var textA = a.installmentPeriod;
          var textB = b.installmentPeriod;
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
      this.epp6Or12MonthsMinAmount = Math.min(
        ...this.epp6Or12MonthsChargeList.map((eppCharge) => eppCharge.minAmount)
      );
      this.showEPP6Or12Months =
        this.totalPriceBeforeCharges >= this.epp6Or12MonthsMinAmount;

      const groupByBankName2 = this.epp6Or12MonthsChargeList.reduce(
        (group, eppCharge) => {
          const { bankName } = eppCharge;
          group[bankName] = group[bankName] ?? [];
          group[bankName].push(eppCharge);
          return group;
        },
        {}
      );

      this.epp6Or12MonthsChargeDistinctList = Object.values(groupByBankName2)
        .map((group) => group[0])
        .sort(function (a, b) {
          var textA = a.bankName.toUpperCase();
          var textB = b.bankName.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    }

    this.setDefaultPaymentMethodForPartner();
  }

  isPreviousTried(method: string): boolean {
    return this.previousTriedPayment === method;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Do this to prevent ExpressionChangedAfterItHasBeenCheckedError
    if (changes.bankCharge && !changes.bankCharge.firstChange) {
      this.totalPriceInstallment3 =
        (this.totalPriceBeforeCharges + this.bankCharge?.["3"]) / 3;
      this.totalPriceInstallment6 =
        (this.totalPriceBeforeCharges + this.bankCharge?.["6"]) / 6;
      this.totalPriceInstallment12 =
        (this.totalPriceBeforeCharges + this.bankCharge?.["12"]) / 12;

      if (this.eppChargeList && this.eppChargeList.length > 0) {
        this.showEPP3Or6Or12Months =
          this.totalPriceBeforeCharges >= this.epp3Or6Or12MonthsMinAmount;
        this.showEPP6Or12Months =
          this.totalPriceBeforeCharges >= this.epp6Or12MonthsMinAmount;
      }

      // Manually trigger change detection
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy(): void {
    this.paymentFormGroup.patchValue({
      paymentType: "",
      paymentProvider: "",
      bank: "",
      installmentMonth: "",
      paymentOptionEPPType: ""
    });
  }

  fpShopeeSelected(event: MatRadioChange) {
    this.paymentFormGroup.patchValue({
      bank: "",
      installmentMonth: "",
      paymentOptionEPPType: "",
      ewalletType: "",
      paymentChannel: "ShopeePay",
      paymentOptionFPType: this.paymentOptionShopee
    });
  }

  fpGrabSelected(event: MatRadioChange) {
    this.paymentFormGroup.patchValue({
      bank: "",
      installmentMonth: "",
      paymentOptionEPPType: "",
      ewalletType: "",
      paymentChannel: "GrabPay",
      paymentOptionFPType: this.paymentOptionGrab
    });
  }

  fpRazerSelected(event: MatRadioChange) {
    this.paymentFormGroup.patchValue({
      paymentChannel: "credit",
      paymentOptionFPType: this.paymentOptionRazer
    });
  }

  fpKITSSelected(event: MatRadioChange) {
    this.paymentFormGroup.patchValue({
      paymentChannel: "KITS",
      paymentProvider: this.paymentOptionMPay
    });
  }

  epp3Or6Or12MonthsSelected(event: MatRadioChange) {
    this.paymentFormGroup.patchValue({
      paymentProvider: this.paymentOptionRazer,
      paymentOptionEPPType: this.paymentOptionEPP3Or6Or12Months
    });
  }

  epp6or12MonthsSelected(event: MatRadioChange) {
    this.paymentFormGroup.patchValue({
      paymentProvider: this.paymentOptionPayex,
      paymentOptionEPPType: this.paymentOptionEPP6Or12Months
    });
  }

  eppBankSelected(event: MatRadioChange) {
    this.paymentFormGroup.patchValue({
      installmentMonth: ""
    });
  }

  atomeBNPLSelected(event: MatRadioChange){
    this.paymentFormGroup.controls.paymentChannel.setValidators([]);
    this.paymentFormGroup.controls?.bank.setValidators([]);
    this.paymentFormGroup.controls?.installmentMonth.setValidators([]);
    this.paymentFormGroup.controls?.paymentOptionFPType.setValidators([]);
    this.paymentFormGroup.controls.bank.reset();
    this.paymentFormGroup.controls.installmentMonth.reset();
    this.paymentFormGroup.controls.ewalletType.reset();

    this.paymentFormGroup.patchValue({
      paymentProvider: this.paymentOptionAtome,
      paymentChannel: this.paymentOptionAtome,
      bank: "",
      installmentMonth: "",
      paymentOptionEPPType: "",
      ewalletType: "",
      paymentOptionFPType: ""
    });
  }

  ahaPayBNPLSelected(event: MatRadioChange){
    this.paymentFormGroup.controls.paymentChannel.setValidators([]);
    this.paymentFormGroup.controls?.bank.setValidators([]);
    this.paymentFormGroup.controls?.installmentMonth.setValidators([]);
    this.paymentFormGroup.controls?.paymentOptionFPType.setValidators([]);
    this.paymentFormGroup.controls.bank.reset();
    this.paymentFormGroup.controls.installmentMonth.reset();
    this.paymentFormGroup.controls.ewalletType.reset();
    
    this.paymentFormGroup.patchValue({
      paymentProvider: this.paymentOptionAhaPay,
      paymentChannel: this.paymentOptionAhaPay,
      bank: "",
      installmentMonth: "",
      paymentOptionEPPType: "",
      ewalletType: "",
      paymentOptionFPType: ""
    });
  }

  lendaPayBNPLSelected(){
    this.paymentFormGroup.controls.paymentChannel.setValidators([]);
    this.paymentFormGroup.controls?.bank.setValidators([]);
    this.paymentFormGroup.controls?.installmentMonth.setValidators([]);
    this.paymentFormGroup.controls?.paymentOptionFPType.setValidators([]);
    this.paymentFormGroup.controls.bank.reset();
    this.paymentFormGroup.controls.installmentMonth.reset();
    this.paymentFormGroup.controls.ewalletType.reset();

    this.paymentFormGroup.patchValue({
      paymentProvider: this.paymentOptionLendaPay,
      paymentChannel: this.paymentOptionLendaPay,
      bank: "",
      installmentMonth: "",
      paymentOptionEPPType: "",
      ewalletType: "",
      paymentOptionFPType: ""
    });
  }

  filterListBasedOnSelectedBanks(list: any[]) {
    return list.filter((x) => x.bankName === this.paymentFormGroup.value.bank);
  }

  getPaymentMonthLabel(period: number) {
    if (period == 3) return "paymentOptions.3months";
    if (period == 6) return "paymentOptions.6months";
    if (period == 12) return "paymentOptions.12months";

    return "";
  }

  getTotalPriceInstallment(period: number) {
    if (period == 3) return this.totalPriceInstallment3;
    if (period == 6) return this.totalPriceInstallment6;
    if (period == 12) return this.totalPriceInstallment12;

    return 0;
  }

  get paymentTypeVal() {
    return this.paymentFormGroup?.value?.paymentType;
  }

  get paymentChannelVal() {
    return this.paymentFormGroup?.value?.paymentChannel;
  }

  get paymentOptionFPTypeVal() {
    return this.paymentFormGroup?.value?.paymentOptionFPType;
  }

  private setDefaultPaymentMethodForPartner() {
    if (this.partnerCode == "kits") {
      let formGroup = this.paymentFormGroup.controls;

      formGroup?.bank.setValidators([]);
      formGroup?.installmentMonth.setValidators([]);
      formGroup?.paymentOptionFPType.setValidators([]);

      formGroup.bank.reset();
      formGroup.installmentMonth.reset();
      formGroup.ewalletType.reset();

      // this.paymentFormGroup.patchValue({
      //   paymentProvider: this.paymentOptionMPay,
      //   paymentChannel: this.paymentOptionKITS,
      //   paymentOptionFPType: ""
      // });
    }
    else if (this.partnerCode == "grabc" && this.paymentOptionsCondition?.enableGrabMiniApp) {
      this.paymentFormGroup.patchValue({
        paymentChannel: "GrabMiniApp",
        paymentProvider: this.paymentOptionGrabMiniApp
      });
    }
  }

  isLendaPayOptionAvailable() {
    var result = (
      (!this.paymentOptionsCondition || this.paymentOptionsCondition.enableLendaPay) &&
      this.isTakafulProduct &&
      (this.totalPrice >= 30 && this.totalPrice <= 10000)
    );

    return result;
  }
}
